import 'core-js/fn/array/includes'


// WEBPACK FOOTER //
// ./src/polyfills.js